<script lang="ts">
  import { store, type Tab } from '../lib/stores.svelte.js';

  const tabs: { id: Tab; label: string }[] = [
    { id: 'map',        label: 'Map' },
    { id: 'rankings',   label: 'Rankings' },
    { id: 'diagnostic', label: 'Diagnostic' },
  ];
</script>

<div class="tabs" role="tablist">
  {#each tabs as t (t.id)}
    <button
      class="tab"
      class:active={store.tab === t.id}
      role="tab"
      aria-selected={store.tab === t.id}
      onclick={() => store.setTab(t.id)}
    >{t.label}</button>
  {/each}
</div>

<style>
  .tabs {
    display: flex;
    gap: 2px;
    border-bottom: 1px solid var(--color-border);
  }
  .tab {
    font-family: var(--font-ui);
    font-size: var(--text-sm);
    font-weight: var(--weight-semibold);
    letter-spacing: var(--tracking-wide);
    text-transform: uppercase;
    color: var(--color-text-muted);
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    padding: var(--space-md) var(--space-lg);
    cursor: pointer;
    transition: color var(--duration-base) var(--ease-standard),
                border-color var(--duration-base) var(--ease-standard);
  }
  .tab:hover { color: var(--color-blue); }
  .tab.active {
    color: var(--color-navy);
    border-bottom-color: var(--color-blue);
  }
  .tab:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
    border-radius: var(--radius-sm);
  }
</style>
